import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css"; // optional if you want custom CSS

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src="/logo.png" alt="Gen Z Skills Logo" className="logo" />
        <span className="brand-name">Gen Z Skills</span>
      </div>
      <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/courses">Courses</Link></li>
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
